import html2canvas from "html2canvas";

// Oynanan kuponun EKRAN GÖRÜNTÜSÜ gönderim gövdesinde sunucuya gidiyor. Görsel kuponun
// kendisi değil, yanında giden bir EK: üretilemezse boş string gönderilip kupon yine oynanıyor.
//
// Üç bahis türünün üçü de bu görüntüyü "Oyna" düğmesine basıldığı anda, BAHİS DETAYI onay
// modalı açılmadan ÖNCE çekiyordu ve modalı bu işin bitmesini BEKLETİYORDU. İki maliyeti
// vardı, ikisi de buradan çözülüyor:
//
// 1) html2canvas, ilk `await`ine gelmeden ÖNCE (yani çağrı anında, senkron) TÜM BELGEYİ
//    klonluyor ve klonladığı her düğüm için üç `getComputedStyle` çağırıyor (elemanın
//    kendisi, ::before, ::after). Bülten tablosu açıkken bu binlerce düğüm demek; onay modalı
//    saniyelerce gecikiyordu. `ignoreElements` ile klon KUPONUN KENDİSİ + ata zinciri +
//    <head> ile sınırlanıyor (stil sayfaları klonda gerekli, yoksa görüntü stilsiz çıkar);
//    sayfanın geri kalanına hiç girilmiyor.
//
// 2) Klon çağrı anında senkron alındığı için `await` etmeye gerek YOK: anlık görüntü o anki
//    DOM'u yakalıyor, hemen ardından açılan modal görüntüye giremiyor. Bu yüzden çağıran
//    modalı beklemeden açıyor, promise'i ancak gönderim anında (`resolveCouponImage`)
//    çözüyor. Kullanıcı modalı okurken görüntü arka planda bitiyor.
export type CouponImage = string | Promise<string> | undefined;

// Gönderim görüntü yüzünden beklemesin: oran/kapanış saatine bağlı bir yüzeyde birkaç yüz
// milisaniye bile pahalı. Süre dolarsa kupon görüntüsüz gidiyor.
const CAPTURE_TIMEOUT_MS = 2000;

/**
 * Klonda kuponu KIRPAN kapları açar.
 *
 * Kupon kutusu içeriği sığmayınca scroll ediyor (`.betslip-body` 40vh). Görüntüye yalnız
 * görünen kısım giriyordu; üstelik html2canvas klona scroll konumunu da geri yüklediği için
 * kullanıcı aşağı kaydırmışsa kuponun ÜSTÜ de kesiliyordu.
 *
 * - Kuponun KENDİSİ: boyu koşulsuz serbest (`height: auto`). Böylece uzun kupon içeriği
 *   kadar uzuyor, kısa kupon da altında boş beyaz alan bırakmıyor.
 * - İÇİNDEKİ kaplar: yalnız gerçekten taşıyorsa serbest bırakılıyor - taşmayan bir kutunun
 *   ölçüsüyle oynamanın sebebi yok.
 * - ATALARI: yalnız kırpmaları kaldırılıyor, BOYLARINA DOKUNULMUYOR. Ata boyunu `auto`
 *   yapmak (ör. `height: 100vh` olan kabuk) kuponun klondaki yerini kaydırırdı.
 *
 * Ölçüm ile yazma ayrı turlarda: mutasyon sırasında `scrollHeight` okumak hem yerleşimi
 * her adımda yeniden hesaplatır hem de kendi değişikliğimizi ölçmeye başlar.
 */
function unclipScrollers(clone: HTMLElement): void {
    const isOverflowing = (node: HTMLElement) =>
        node.scrollHeight > node.clientHeight + 1 || node.scrollWidth > node.clientWidth + 1;

    const overflowing = Array.from(clone.querySelectorAll<HTMLElement>("*")).filter(isOverflowing);

    const ancestors: HTMLElement[] = [];
    for (let parent = clone.parentElement; parent; parent = parent.parentElement) {
        ancestors.push(parent);
    }

    [clone, ...overflowing].forEach((node) => {
        node.style.overflow = "visible";
        node.style.maxHeight = "none";
        node.style.height = "auto";
    });
    ancestors.forEach((node) => {
        node.style.overflow = "visible";
        node.style.maxHeight = "none";
    });
}

/**
 * Kupon görüntüsünü ÜRETMEYE BAŞLAR ve promise'ini döner. Promise asla reddetmez;
 * üretilemezse boş string ile çözülür. Modal açmadan hemen önce, `await` ETMEDEN çağır.
 */
export function startCouponImageCapture(elementId: string): Promise<string> {
    try {
        const element = document.getElementById(elementId);
        if (!element || element.clientWidth === 0 || element.clientHeight === 0) {
            return Promise.resolve("");
        }

        const head = element.ownerDocument.head;
        const computed = window.getComputedStyle(element);

        return html2canvas(element, {
            width: element.clientWidth,
            // `height` BİLEREK verilmiyor: html2canvas yüksekliği `onclone`dan SONRA klonun
            // sınırlarından okuyor, yani kırpması açılmış kuponun tam boyu kendiliğinden
            // geliyor. Canlı `clientHeight` verilseydi görüntü yine görünen kutuda kalırdı.
            // Tam çözünürlük gereksiz büyük bir gövde üretiyor.
            scale: 0.7,
            logging: false,
            // Varsayılan 15 sn: yüklenemeyen tek bir görsel tüm çekimi kilitliyordu.
            imageTimeout: 3000,
            ignoreElements: (node: Element) =>
                !(node.contains(element) || element.contains(node) || head.contains(node)),
            // Kardeşleri atmak klonda düzeni kaydırabilir (esnek kapsayıcıda kupon genişler).
            // Kuponun GENİŞLİĞİ canlı ölçüsüne sabitleniyor: konumu değişebilir - html2canvas
            // zaten KLONDAKİ konumu okuyor - ama eni birebir kalıyor. Boy sabitlenmiyor,
            // `unclipScrollers` onu içeriğe bırakıyor.
            onclone: (_doc: Document, clone: HTMLElement) => {
                clone.style.boxSizing = "content-box";
                clone.style.width = computed.width;
                clone.style.minWidth = "0";
                clone.style.maxWidth = "none";
                clone.style.flex = "none";
                unclipScrollers(clone);
            },
        })
            .then((canvas) => canvas.toDataURL("image/jpeg"))
            .catch((error) => {
                console.error("Kupon görüntüsü üretilemedi", error);
                return "";
            });
    } catch (error) {
        console.error("Kupon görüntüsü üretilemedi", error);
        return Promise.resolve("");
    }
}

/** Gönderim anında görüntüyü çözer; süre dolarsa boş string döner, kupon beklemez. */
export function resolveCouponImage(image: CouponImage, timeoutMs: number = CAPTURE_TIMEOUT_MS): Promise<string> {
    if (typeof image === "string") return Promise.resolve(image);
    if (!image) return Promise.resolve("");

    return Promise.race([
        image,
        new Promise<string>((resolve) => setTimeout(() => resolve(""), timeoutMs)),
    ]).catch(() => "");
}
